<template>
    <div>
        <page-header :heading="pageHeader.title" />

        <div>
            <b-card-group deck>
                <b-card title="Upload">
                    <b-card-text>
                        Upload worklist file(s).
                    </b-card-text>
                    <router-link to="/finance/supplierpayments/import" class="card-link">Go</router-link>
                </b-card>

                <b-card title="Process">
                    <b-card-text>
                        Check workitems and create batch(es).
                    </b-card-text>
                    <router-link to="/finance/supplierpayments/progress" class="card-link">Go</router-link>
                </b-card>

                <b-card title="Pay">
                    <b-card-text>
                        Mark batches as paid.
                    </b-card-text>
                    <!--<router-link to="/finance/supplierpayments/progress" class="card-link">Go</router-link>-->
                </b-card>
            </b-card-group>
        </div>
    </div>
</template>
<script>
    import PageHeader from '@/components/PageHeader.vue'
    import RecentClaims from '@/components/RecentClaims.vue'
    import { mapActions, mapGetters } from "vuex";
    export default {
        components: {
            'page-header': PageHeader,
            'recent-claims': RecentClaims
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Finance'
                }
            }
        },
        beforeMount() {
            this.clearClaimsList()
        },
        mounted() {
            this.loadRecentClaimList()
        },
        computed: {
            ...mapGetters({
                recentClaimList: 'recentClaimStore/recentClaimList'
            })
        },
        methods: {
            ...mapActions({
                loadRecentClaimList: "recentClaimStore/fetchRecentClaimsList",
                fetchSelectedClaimEx: 'fetchSelectedClaimEx',
                clearClaimsList: 'clearClaimsList',
                clearSelectedClaim: 'clearSelectedClaim',
                setSelectedClaimIndex: 'setSelectedClaimIndex'
            }),
            goToClaim(id, idx) {
                this.clearSelectedClaim()
                this.setSelectedClaimIndex(idx)
                this.fetchSelectedClaimEx(id)
                this.$router.push('/dashboard/myrecentclaims/approve')
            }
        }
    }
</script>